import {useContext} from "react";
import {ScreenDesignerContextNew} from "../../../../../../../../ContextComponents/ScreenDesignerContextNew";

export function useComponentProperties() {
    const {
        selectedComponent = {},
        screenValues: {otherComponents = []},
        listStorage,
    } = useContext(ScreenDesignerContextNew);
    const {component} = selectedComponent;

    const propsSchema = {
        button: [
            {
                label: 'Label',
                name: 'label',
                type: 'string',
                multiLanguage: true,
                visibleIf: (props) => props.type !== "iconButton",
            },
            {
                label: "Type", name: 'type', type: 'objSelect', optLabel: "label", values: [
                    {label: 'Default', value: 'default'},
                    {label: 'Icon Button', value: 'iconButton'}
                ]
            },
            {
                label: "Validate Fields", name: 'validateFields', type: 'objSelect', optLabel: "label", values: [
                    {label: 'True', value: true},
                    {label: 'False', value: false}
                ]
            },
            {label: 'Disabled Condition', name: 'disabledCondition', type: 'script'},
            {label: 'Hide Condition', name: 'hideCondition', type: 'script'},
            {
                label: "Icon",
                type: 'iconType',
                visibleIf: (props) => props.type === "iconButton",
            },
            {label: 'Tooltip', name: 'tooltip', type: 'text', multiLanguage: true},
            {
                label: "Start Icon", name: 'startIcon', type: 'iconType',
                visibleIf: (props) => props.type !== "iconButton",
            },
            {
                label: "End Icon", name: 'endIcon', type: 'iconType',
                visibleIf: (props) => props.type !== "iconButton",
            },
            {
                label: "Active State Condition", name: 'activeState', type: 'script',
                visibleIf: (props) => props.type !== "iconButton",
            },
        ],
        label: [
            {label: 'Label', name: 'label', type: 'string', multiLanguage: true},
            {label: 'Hide Condition', name: 'hideCondition', type: 'script'},
        ],
        tabs: [
            {
                label: "Variant", name: 'variant', type: 'objSelect', optLabel: "label", values: [
                    {label: 'Standard', value: 'standard'},
                    {label: 'Full Width', value: 'fullWidth'},
                    {label: 'Scrollable', value: 'scrollable'},
                ]
            }
        ],
        tab: [
            {label: 'Label', name: 'label', type: 'string', multiLanguage: true},
            {
                label: "Render When Visible", name: 'renderWhenVisible', type: 'objSelect', optLabel: "label", values: [
                    {label: 'True', value: true},
                    {label: 'False', value: false}
                ]
            },
        ],
        list: [
            {label: 'Name', name: 'name', type: 'string', dropdown: 'listDropdownList'},
            {label: 'Disabled checkbox condition', name: 'disabledCheckbox', type: 'script'},
            {
                label: "Skip Init Data Load", name: 'skipInitDataLoad', type: 'objSelect', optLabel: "label", values: [
                    {label: 'True', value: true},
                    {label: 'False', value: false}
                ]
            },
            {label: 'Context', name: 'context', type: 'script'},
        ],
        field: [
            {label: 'Name', name: 'name', type: 'string'},
            {label: 'Label', name: 'label', type: 'string', multiLanguage: true},
            {label: 'Data Source', name: 'path', type: 'string'},
            {
                label: "Disabled", name: 'disabled', type: 'script', optLabel: "label"
            },
            {label: 'Placeholder', name: 'placeholder', type: 'string', multiLanguage: true},
            {label: 'Hide Condition', name: 'hideCondition', type: 'script'},
            {
                label: 'Type', name: 'type', type: 'objSelect', optLabel: "label", values: [
                    {label: "String", value: "string"},
                    {label: "Number", value: "number"},
                    {label: "Integer", value: "integer"},
                    {label: "Date", value: "date"},
                    {label: "Month", value: "month"},
                    {label: "Time", value: "time"},
                    {label: "Date Time", value: "datetime"},
                    {label: "Duration", value: 'duration'},
                    {label: "Boolean", value: "bool"},
                    {label: "Entity External", value: "entityExternal"},
                    {label: "Entity Embedded", value: "entityEmbedded"},
                    {label: "Entity Mixed", value: "entityMixed"},
                    {label: "JSON", value: 'jsonObject'},
                    {label: "Script", value: 'script'},
                    {label: "Frequency", value: 'frequency'},
                    {label: "Text", value: 'text'},
                    {label: "Location", value: 'location'},
                    {label: "String (Password)", value: "password"},
                    {label: "Color Picker", value: "colorPicker"},
                ]
            },
            {
                label: 'Entity', name: 'entity', type: "string", dropdown: 'schemaDropdownList',
                visibleIf: (props) => props.type === "entityExternal",
            },
            {
                label: 'Disable Keydown', name: 'disableKeydown', type: 'objSelect', optLabel: "label", values: [
                    {label: 'True', value: true},
                    {label: 'False', value: false}
                ],
                visibleIf: (props) => ['date', 'time', 'month'].includes(props.type),
            },
            {
                label: 'Input Mode', name: 'inputMode', type: 'objSelect', optLabel: "label", values: [
                    {label: "Popup", value: "inPopup"},
                    {label: "Inline", value: "inline"},
                ],
                visibleIf: (props) => ['script', 'jsonObject'].includes(props.type),
            },
            {
                label: 'Required', name: 'required', type: 'objSelect', optLabel: "label", values: [
                    {label: 'True', value: true},
                    {label: 'False', value: false}
                ]
            },
            {
                label: 'Time Required', name: 'timeRequired', type: 'objSelect', optLabel: "label", values: [
                    {label: 'True', value: true},
                    {label: 'False', value: false}
                ],
                visibleIf: (props) => props.type === "frequency",
            },
            {
                label: 'Allowed types', name: 'allowedFrequencyTypes',
                isArray: true,
                type: "string", dropdown: 'frequencyTypeDropdownList',
                visibleIf: (props) => props.type === "frequency",
            },
            {
                label: 'Is Array', name: 'isArray', type: 'objSelect', optLabel: "label", values: [
                    {label: 'True', value: true},
                    {label: 'False', value: false}
                ],
                visibleIf: (props) => props.type !== "frequency",
            },
            {
                label: 'Array Type', name: 'arrayType', type: 'objSelect', optLabel: "label", values: [
                    {label: 'Vertical', value: 'vertical'},
                    {label: 'Horizontal', value: 'horizontal'}
                ],
                visibleIf: (props) => props.type === "entityEmbedded" && props.isArray,
            },
            {
                label: 'Dropdown', name: 'dropdown', type: 'string', dropdown: "screenDropdownList",
                visibleIf: (props) => props.type !== "frequency",
            },
            {
                label: 'Dropdown Context', name: 'dropdownContext', type: 'script',
                visibleIf: (props) => props.dropdown || props.entity,
            },
            {
                label: 'Value Dropdown Only', name: 'valueDropdownOnly', type: 'objSelect', optLabel: "label", values: [
                    {label: 'True', value: true},
                    {label: 'False', value: false}
                ],
                visibleIf: (props) => props.type !== 'frequency' && (props.dropdown || props.entity),
            },
            {label: 'AutoFill Name', name: 'autocomplete', type: 'string'},
            {
                label: 'Autofocus', name: 'autofocus', type: 'objSelect', optLabel: "label", values: [
                    {label: 'True', value: true},
                    {label: 'False', value: false}
                ]
            },
            {label: 'Pattern', name: 'pattern', type: 'string'},
            {label: 'Pattern Title', name: 'patternTitle', type: 'string', multiLanguage: true},
            {
                label: 'Values', name: 'values', type: 'string', isArray: true,
                visibleIf: (props) => ['string', 'number', 'integer'].includes(props.type)
            },
            {label: 'Help Text', name: 'helpText', type: 'string', dropdown: "helpTextDropdownList"},
            {label: 'Start Icon', name: 'startAdornment', type: 'string'},
            {label: 'End Icon', name: 'endAdornment', type: 'string'},
            {
                label: 'Set value on change', name: 'setValueOnChange', type: 'objSelect', optLabel: "label", values: [
                    {label: 'True', value: true},
                    {label: 'False', value: false}
                ]
            },
            {
                label: 'Restrict Create', name: 'restrictCreate', type: 'objSelect', optLabel: "label", values: [
                    {label: 'True', value: true},
                    {label: 'False', value: false}
                ],
                visibleIf: (props) => props.type === 'entityExternal',
            },
        ],
        fieldArray: [
            {label: 'Data Source', name: 'path', type: 'string'},
            {
                label: 'Array Type', name: 'arrayType', type: 'objSelect', optLabel: "label", values: [
                    {label: 'Vertical', value: 'vertical'},
                    {label: 'Horizontal', value: 'horizontal'}
                ]
            },
            {label: 'Hide Condition', name: 'hideCondition', type: 'script'},
            {
                label: 'Allow Create', name: 'allowCreate', type: 'objSelect', optLabel: "label", values: [
                    {label: 'True', value: true},
                    {label: 'False', value: false}
                ]
            },
            {
                label: 'Allow Delete', name: 'allowDelete', type: 'objSelect', optLabel: "label", values: [
                    {label: 'True', value: true},
                    {label: 'False', value: false}
                ]
            },
        ],
        fieldEntity: [
            {label: 'Name', name: 'name', type: 'string'},
            {label: 'Label', name: 'label', type: 'string'},
            {
                label: 'Required', name: 'required', type: 'objSelect', optLabel: "label", values: [
                    {label: 'True', value: true},
                    {label: 'False', value: false}
                ]
            },
            {
                label: "Disabled", name: 'disabled', type: 'objSelect', optLabel: "label", values: [
                    {label: 'True', value: true},
                    {label: 'False', value: false}
                ]
            },
            {
                label: 'Is Array', name: 'isArray', type: 'objSelect', optLabel: "label", values: [
                    {label: 'True', value: true},
                    {label: 'False', value: false}
                ]
            },
            {
                label: 'Type', name: 'type', type: 'objSelect', optLabel: "label", values: [
                    {label: "String", value: "string"},
                    {label: "Number", value: "number"},
                    {label: "Integer", value: "integer"},
                    {label: "Date", value: "date"},
                    {label: "Time", value: "time"},
                    {label: "Date Time", value: "datetime"},
                    {label: "Duration", value: 'duration'},
                    {label: "Boolean", value: "bool"},
                    {label: "Entity External", value: "entityExternal"},
                    {label: "Entity Embedded", value: "entityEmbedded"},
                    {label: "Entity Mixed", value: "entityMixed"},
                    {label: "JSON", value: 'jsonObject'},
                    {label: "Script", value: 'script'},
                    {label: "Frequency", value: 'frequency'},
                    {label: "Text", value: 'text'},
                    {label: "Location", value: 'location'},
                ]
            },
            {label: 'Dropdown', name: 'dropdown', type: 'string', dropdown: "screenDropdownList"},
        ],
        image: [
            {label: 'Source Id', name: 'sourceId', type: 'string', dropdown: 'filesDropdownList'},
            {label: 'Content', name: 'content', type: 'string'},
            {label: 'Public Url', name: 'publicUrl', type: 'string'},
            {label: 'Hide Condition', name: 'hideCondition', type: 'script'},
        ],
        chat: [
            {label: 'Source Id', name: 'sourceId', type: 'string'},
            {
                label: "Read Only", name: 'readOnly', type: 'objSelect', optLabel: "label", values: [
                    {label: 'True', value: true},
                    {label: 'False', value: false}
                ]
            },
            {
                label: "Is Chat Bot", name: 'isChatBot', type: 'objSelect', optLabel: "label", values: [
                    {label: 'True', value: true},
                    {label: 'False', value: false}
                ]
            },
            {label: 'Our User', name: 'ourUser', type: 'string'},
        ],
        band: [
            {
                label: "Type", name: 'type', type: 'objSelect', optLabel: "label", values: [
                    {label: 'Page Header', value: 'pageHeader'},
                    {label: 'Page Footer', value: 'pageFooter'},
                ]
            }
        ],
        embeddedScreen: [
            {label: 'Screen Id', name: 'sourceId', type: 'string', dropdown: 'screenDropdownList'},
            {label: 'Base Path', name: 'basePath', type: 'string'},
        ],
        survey: [
            {label: 'Survey Id', name: 'sourceId', type: 'string', dropdown: 'surveyParamDropdownList'},
            {label: 'Data Source', name: 'dataSource', type: 'string'},
            {
                label: 'Mode', name: 'type', type: 'objSelect', optLabel: "label", values: [
                    {label: 'Design', value: 'design'},
                    {label: 'Player', value: 'player'}
                ]
            }
        ],
        stepper: [
            {
                label: 'Linear', name: 'linear', type: 'objSelect', optLabel: "label", values: [
                    {label: 'True', value: true},
                    {label: 'False', value: false}
                ]
            },
            {
                label: 'Restrict Top Nav', name: 'restrictTopNav', type: 'objSelect', optLabel: "label", values: [
                    {label: 'True', value: true},
                    {label: 'False', value: false}
                ]
            },
            {label: 'Title', name: 'title', type: 'string', multiLanguage: true},
            {label: 'Hide Del Btn', name: 'hideDeleteBtn', type: 'script'},
            {label: 'Hide Back Btn', name: 'hideBackBtn', type: 'script'},
            {label: 'Hide Cancel Btn', name: 'hideCancelBtn', type: 'script'},
            {label: 'Submit Label', name: 'submitLabel', type: 'string', multiLanguage: true},
            {label: 'Next Label', name: 'nextLabel', type: 'string', multiLanguage: true},
            {label: 'Back Label', name: 'backLabel', type: 'string', multiLanguage: true},
            {label: 'Delete Label', name: 'deleteLabel', type: 'string', multiLanguage: true},
            {label: 'Cancel Label', name: 'cancelLabel', type: 'string', multiLanguage: true},

        ],
        step: [
            {label: 'Label', name: 'label', type: 'string', multiLanguage: true},
            {label: 'Is Completed', name: 'isCompleted', type: 'script'},
            {
                label: "Validate Fields", name: 'validateFields', type: 'objSelect', optLabel: "label", values: [
                    {label: 'True', value: true},
                    {label: 'False', value: false}
                ]
            },
            {
                label: "Render When Visible", name: 'renderWhenVisible', type: 'objSelect', optLabel: "label", values: [
                    {label: 'True', value: true},
                    {label: 'False', value: false}
                ]
            },
        ],
        progress: [
            {label: 'Value', name: 'value', type: 'script'},
            {
                label: "Type", name: 'type', type: 'objSelect', optLabel: "label", values: [
                    {label: 'Linear', value: 'linear'},
                    {label: 'Circle', value: 'circle'}
                ]
            },
        ],
        selectionCriteria: [
            {label: 'List Id', name: 'listId', type: 'string', dropdown: 'listDropdownList'},
            {label: 'Field Name', name: 'path', type: 'string'},
            {
                label: 'Type', name: 'type', type: 'objSelect', optLabel: "label", values: [
                    {label: 'App', value: 'app'},
                    {label: 'System', value: 'system'}
                ]
            },
            {
                label: 'Default Value Type', name: 'defaultValueType', type: 'objSelect', optLabel: "label", values: [
                    {label: 'Value Input', value: 'valueInput'},
                    {label: 'Sb Function', value: 'sbFunction'}
                ]
            },
            {
                label: "Hide Value Type Selection",
                name: 'hideValueTypeSelection',
                type: 'objSelect',
                optLabel: "label",
                values: [
                    {label: 'True', value: true},
                    {label: 'False', value: false}
                ],
                visibleIf: (props) => props.type === 'system',
            },
            {
                label: "Show Apply Button", name: 'showApplyButton', type: 'objSelect', optLabel: "label", values: [
                    {label: 'True', value: true},
                    {label: 'False', value: false}
                ]
            },
            {label: 'Apply Button Label', name: 'applyButtonLabel', type: 'string'},
        ],
        text: [
            {
                label: "Type", name: 'type', type: 'objSelect', optLabel: "label", values: [
                    {label: 'Editor', value: 'editor'},
                    {label: 'Preview', value: 'preview'}
                ]
            },
            {
                label: "Multi Language", name: 'multiLanguage', type: 'objSelect', optLabel: "label", values: [
                    {label: 'True', value: true},
                    {label: 'False', value: false}
                ]
            },
            {label: 'Data Source', name: 'path', type: 'string'},
            {
                label: "Preserve Whitespace",
                name: 'preserveWhitespace',
                type: 'objSelect',
                optLabel: "label",
                values: [
                    {label: 'True', value: true},
                    {label: 'False', value: false}
                ]
            },
        ],
        forEach: [
            {label: 'Data Source', name: 'path', type: 'string'},
            {label: 'Container Id', name: 'containerId', type: 'string'},
            {
                label: "Allow Create", name: 'creatable', type: 'objSelect', optLabel: "label", values: [
                    {label: 'True', value: true},
                    {label: 'False', value: false}
                ]
            },
            {
                label: "Allow Remove", name: 'removable', type: 'objSelect', optLabel: "label", values: [
                    {label: 'True', value: true},
                    {label: 'False', value: false}
                ]
            },
            {label: 'List', name: 'list', type: 'string', dropdown: 'listDropdownList'},
            {
                label: "Skip Init Data Load", name: 'skipInitDataLoad', type: 'objSelect', optLabel: "label", values: [
                    {label: 'True', value: true},
                    {label: 'False', value: false}
                ]
            },
            {
                label: 'Virtual List', name: 'isVirtual', type: 'objSelect', values: [
                    {label: 'True', value: true},
                    {label: 'False', value: false}
                ]
            },
            {
                label: 'No Data Label', name: 'noDataLabel', type: 'string'
            },
            {
                label: 'Max Items Render', name: 'maxItemsRender', type: 'number'
            },
        ],
        actionsBar: [
            {
                label: "Entity", name: 'entity', type: 'objSelect', optLabel: "label",
                values: otherComponents.filter(i => i.type === 'entity').map(l => {
                    if (l.properties) return {label: l.properties.name, value: l.properties.name}
                })
            },
        ],
        bottomMenu: [
            {
                label: "Show Labels", name: 'showLabels', type: 'objSelect', optLabel: "label", values: [
                    {label: 'True', value: true},
                    {label: 'False', value: false}
                ]
            },
        ],
        navigationItem: [
            {label: 'Label', name: 'label', type: 'string'},
            {label: 'Icon', name: 'icon', type: 'string'},
        ],
        maps: [
            {label: 'Map Center', name: 'mapCenter', type: 'string'},
            {label: 'Zoom', name: 'zoom', type: 'number'},
        ],
        marker: [
            {label: 'Data Source', name: 'dataSource', type: 'string'},
            {label: 'Location Field', name: 'locationField', type: 'string'},
            {label: 'Icon', name: 'icon', type: 'string'},
            {label: 'Popup Screen', name: 'popupScreen', type: 'string'},
            {label: 'Popup Text', name: 'popupText', type: 'string'},
        ],
        circle: [
            {label: 'Data Source', name: 'dataSource', type: 'string'},
            {label: 'Location Field', name: 'locationField', type: 'string'},
            {label: 'Radius Field', name: 'radiusField', type: 'string'},
        ],
        checkbox: [
            {label: 'Label', name: 'label', type: 'string', multiLanguage: true},
            {label: 'Data Source', name: 'path', type: 'string'},
            {label: 'Value', name: 'value', type: 'string'},
            {
                label: "Disabled", name: 'disabled', type: 'script', optLabel: "label"
            },
            {label: 'Hide Condition', name: 'hideCondition', type: 'script'},
        ],
        switch: [
            {label: 'Label', name: 'label', type: 'string', multiLanguage: true},
            {label: 'Data Source', name: 'path', type: 'string'},
            {label: 'Value', name: 'value', type: 'string'},
            {
                label: "Disabled", name: 'disabled', type: 'objSelect', optLabel: "label", values: [
                    {label: 'True', value: true},
                    {label: 'False', value: false}
                ]
            },
        ],
        dropzone: [
            {label: 'Label', name: 'label', type: 'string', multiLanguage: true},
            {label: 'Data Source', name: 'path', type: 'string'},
            {label: 'Default File Type', name: 'fileType', type: 'string', dropdown: 'fileTypeDropdownList'},
            {
                label: "Disabled", name: 'disabled', type: 'script'
            },
            {
                label: "Multiple", name: 'isArray', type: 'objSelect', optLabel: "label", values: [
                    {label: 'True', value: true},
                    {label: 'False', value: false}
                ]
            },
            {
                label: "Required", name: 'required', type: 'objSelect', optLabel: "label", values: [
                    {label: 'True', value: true},
                    {label: 'False', value: false}
                ]
            },
            {
                label: 'Hide Select Type', name: 'hideSelectType', type: 'objSelect', optLabel: "label", values: [
                    {label: 'True', value: true},
                    {label: 'False', value: false}
                ]
            },
            {label: 'Accepted File Mask', name: 'acceptedFileMask', type: 'string', isArray: true},
            {
                label: 'Accepted File Types',
                name: 'acceptedFileTypes',
                type: 'string',
                isArray: true,
                dropdown: 'fileTypeDropdownList'
            },
            {label: 'Wrong Type Message', name: 'wrongTypeMessage', type: 'string', multiLanguage: true},
            {label: 'Max Size (mb)', name: 'maxSize', type: 'number'},
            {
                label: "Hide dropped files", name: 'hideDroppedFiles', type: "objSelect", optLabel: "label", values: [
                    {label: "True", value: true},
                    {label: "False", value: false},
                ]
            },
            {
                label: 'Show Description', name: 'showDescription', type: 'objSelect', optLabel: "label", values: [
                    {label: 'True', value: true},
                    {label: 'False', value: false}
                ]
            },
            {
                label: "Dropzone Type", name: 'type', type: "objSelect", optLabel: "label", values: [
                    {label: "Drag & Select", value: 'dragAndSelect'},
                    {label: "Drag", value: 'drag'},
                    {label: "Select", value: 'select'},
                ]
            },
            {
                label: "Upload Chunks", name: 'uploadChunks', type: 'objSelect', optLabel: "label", values: [
                    {label: 'True', value: true},
                    {label: 'False', value: false}
                ]
            },

        ],
        icon: [
            {label: 'Icon', type: 'iconType'},
            {label: "Tooltip", name: 'tooltip', type: 'string', multiLanguage: true},
            {label: 'Hide Condition', name: 'hideCondition', type: 'script'},
        ],
        feed: [
            {label: 'List', name: 'list', type: 'string', dropdown: 'listDropdownList'},
        ],
        searchBar: [
            {
                label: 'List',
                name: 'list',
                type: 'objSelect',
                optLabel: "label",
                values: listStorage.map(v => ({label: v, value: v}))
            },
        ],
        badge: [{label: 'Label', name: 'label', type: 'string'}],
        interval: [{label: 'Interval', name: 'interval', type: 'number'}],
        rating: [
            {label: 'Data Source', name: 'path', type: 'string'},
            {
                label: "Disabled", name: 'disabled', type: 'objSelect', optLabel: "label", values: [
                    {label: 'True', value: true},
                    {label: 'False', value: false}
                ]
            },
            {
                label: "Read Only", name: 'readOnly', type: 'objSelect', optLabel: "label", values: [
                    {label: 'True', value: true},
                    {label: 'False', value: false}
                ]
            },
        ],
        radioGroup: [
            {label: 'Data Source', name: 'path', type: 'string'},
            {label: 'Label', name: 'label', type: 'string', multiLanguage: true},
            {label: 'Items', name: 'items', type: 'string', isArray: true},
            {label: 'Items Data', name: 'itemsData', type: 'string'},
        ],
        menu: [
            {
                label: "Menu", name: 'menu', type: 'string', dropdown: 'menuDropdownList'
            },
            {
                label: "Mode", name: 'mode', type: 'objSelect', optLabel: "label", values: [
                    {label: 'Vertical', value: 'vertical'},
                    {label: 'Horizontal', value: 'horizontal'},
                    {label: "Big Footer Menu", value: 'footerMenu'}
                ]
            },
            {
                label: "Enable Search", name: 'enableSearch', type: 'objSelect', optLabel: "label", values: [
                    {label: 'True', value: true},
                    {label: 'False', value: false}
                ]
            },
        ],
        menuItem: [
            {label: "Label", name: 'label', type: 'string', multiLanguage: true},
            {
                label: 'Icon', type: 'iconType',
            },
            {label: "Url", name: 'url', type: 'string'},
            {label: "Scroll to Block (id)", name: "anchor", type: "string"},
            {label: "Sub menu", name: 'subRef', type: 'string', dropdown: 'menuDropdownList'},
            {label: "Tooltip", name: 'tooltip', type: 'string'},
            {label: "Badge", name: 'badgeValue', type: 'string'},
            {label: 'Disabled Condition', name: 'disabledCondition', type: 'script'},
        ],
        block: [
            {label: 'Element Id', name: 'elementId', type: 'string'},
            {label: 'Hide Condition', name: 'hideCondition', type: 'script'},
            {label: "Active State Condition", name: 'activeState', type: 'script'},
            {label: 'Tooltip', name: 'tooltip', type: 'string', multiLanguage: true},
        ],
        swiper: [
            {label: 'Source', name: 'source', type: 'string', dropdown: 'listDropdownList'},
            {
                label: 'Type', name: 'type', type: 'objSelect', optLabel: "label", values: [
                    {label: 'Carousel', value: 'carousel'},
                    {label: 'Swiper', value: 'swiper'}
                ]
            },
            {
                label: 'Autoplay', name: 'autoplay', type: 'objSelect', optLabel: "label", values: [
                    {label: 'True', value: true},
                    {label: 'False', value: false}
                ]
            },
            {
                label: 'Pagination', name: 'pagination', type: 'objSelect', optLabel: "label", values: [
                    {label: 'True', value: true},
                    {label: 'False', value: false}
                ]
            },
            {label: 'Slides per view', name: 'slidesPerView', type: 'number'},
            {label: 'Space Between', name: 'spaceBetween', type: 'number'},
        ],
        accordion: [
            {label: 'Label', name: 'label', type: 'string', multiLanguage: true},
            {label: 'Content', name: 'content', type: 'string', multiLanguage: true},
            {
                label: 'Type', name: 'type', type: "objSelect", optLabel: "label", values: [
                    {label: "Unstyled", value: 'unstyled'},
                    {label: "Styled", value: 'styled'},
                ]
            },
        ],
        options: [
            {label: 'Label', name: 'label', type: 'string', multiLanguage: true},
            {label: 'Path', name: 'path', type: 'string'},
            {label: 'Var Source', name: 'varSource', type: 'string'},
            {label: 'List Source', name: 'listSource', type: 'string'},
            {label: 'Value Field', name: 'valueField', type: 'string'},
            {
                label: "Multiple", name: 'multiple', type: 'objSelect', optLabel: "label", values: [
                    {label: 'True', value: true},
                    {label: 'False', value: false}
                ]
            },
        ],
        fullView: [
            {label: 'Entity', name: 'entity', type: 'string', dropdown: 'schemaDropdownList'},
            {
                label: "Preview Mode", name: 'previewMode', type: 'objSelect', optLabel: "label", values: [
                    {label: 'True', value: true},
                    {label: 'False', value: false}
                ]
            },
        ],
        serverTime: [
            {label: "Source", name: 'source', type: 'script'},
            {label: "Refresh time", name: 'refreshTime', type: 'number'},
            {label: "Format", name: 'format', type: 'string'},
        ],
        context: [
            {
                label: "Menu", name: 'context', type: 'string', dropdown: 'menuDropdownList',
            },
            {
                label: "Position Target", name: 'type', type: 'objSelect', optLabel: "label", values: [
                    {label: 'Mouse', value: 'mouse'},
                    {label: 'Component', value: 'component'},
                ]

            }
        ],
        camera: [],
        pdfReader: [
            {
                label: "File ID", name: 'source', type: 'string'
            },
            {
                label: "File Content", name: 'content', type: 'string'
            },
        ],
        restrictions: [
            {
                label: "Entity", name: 'entity', type: 'string', dropdown: 'schemaDropdownList',
            },
            {
                label: "Data Source", name: 'dataSource', type: 'string',
            },
        ],
        sidebar: [
            {
                label: 'Toggle Button', name: 'toggleButton', type: 'objSelect',
                optLabel: "label", values: [
                    {label: 'True', value: true},
                    {label: 'False', value: false}
                ]
            },
            {
                label: 'Closed Compact', name: 'closedCompact', type: 'objSelect',
                optLabel: "label", values: [
                    {label: 'True', value: true},
                    {label: 'False', value: false}
                ]
            },
            {label: 'Opened Icon', name: 'openedIcon', type: 'string'},
            {label: 'Closed Icon', name: 'closedIcon', type: 'string'},
            {label: 'Padding Top', name: 'paddingTop', type: 'number'},
            {label: 'Sidebar Open Width', name: 'sidebarOpenWidth', type: 'number'},
        ],
        table: [
            {label: 'Path', name: 'path', type: 'string'},
            {
                label: 'Allow Actions', name: 'allowActions', type: 'objSelect',
                optLabel: "label", values: [
                    {label: 'True', value: true},
                    {label: 'False', value: false}
                ]
            },
            {
                label: 'Paged', name: 'paged', type: 'objSelect',
                optLabel: "label", values: [
                    {label: 'True', value: true},
                    {label: 'False', value: false}
                ]
            },
            {
                label: 'Hide Header', name: 'hideHeader', type: 'objSelect',
                optLabel: "label", values: [
                    {label: 'True', value: true},
                    {label: 'False', value: false}
                ]
            },
            {
                label: 'Page Size', name: 'pageSize', type: 'objSelect',
                optLabel: "label", values: [
                    {label: '5', value: 5},
                    {label: '10', value: 10},
                    {label: '25', value: 25},
                    {label: '50', value: 50},
                    {label: '100', value: 100},
                ],
                visibleIf: (props) => props?.paged,
            },

        ],
        tableTd: [
            {label: 'Col Span', name: 'colSpan', type: 'string'},
        ],
        tableTh: [
            {label: 'Col Span', name: 'colSpan', type: 'string'},
        ],
        dataSource: [
            {label: 'Data Source', name: 'dataSource', type: 'string', dropdown: 'dataSourceDropdownList'},
        ],
        tree: [
            {label: 'Data Source', name: 'path', type: 'string'},
            {label: 'Children Key', name: 'childrenKey', type: 'string'},
            {
                label: 'Variant', name: 'variant', type: 'objSelect',
                optLabel: "label", values: [
                    {label: 'Vertical', value: 'vertical'},
                    {label: 'Horizontal', value: 'horizontal'}
                ]
            },
        ]
    }

    function generateProperties(selectedComponent) {
        if (selectedComponent && selectedComponent.type) {
            const currentSchema = propsSchema[selectedComponent.type]
            if (!currentSchema) return null;

            return currentSchema.map(property => {
                if (property.visibleIf) {
                    let isVisible = property.visibleIf(selectedComponent.properties);
                    return isVisible ? property : null
                }

                return property
            }).filter(v => v)

        }
        return null
    }

    return generateProperties(component)
}
